import React from 'react';
const CohortsCard = ({ Info }) => {
    const CohortImg=`
    .cohort-img img{
     height:60px;
     width:80px;
    }
    `
    return (
        <>
        <style>{CohortImg}</style>
        <div
            className="d-flex justify-content-end col-12" >
            <a target="_blank" className="text-decoration-none" href={Info?.link && Info?.link[0]?.text}>
                <div className="innovation-card ">
                    <div className=" cohort-img p-2">
                        {Info?.logo?.url ?
                        <img
                            src={ Info?.logo?.url } 
                            alt="logo"
                           
                        />
                        :null
                    }
                    </div>
                    <div className=" d-flex flex-column innovation-body ps-4">
                        {
                           !Info?.logo?.url &&   <p className="primary-text cohort-title primary-fnt  m-0  fw-bold">{Info?.card_title[0]?.text} </p>
                        }
                      
                        <p className="primary-fnt  primary-text m-0"> {Info?.card_description[0]?.text} </p>
                    </div>
                </div>
            </a>

        </div>
        </>
    );
};

export default CohortsCard;